import React from "react";
import { supplierFeatureMenu } from "../../data/supplierFeatureMenu";
import ListItem from "../ListItem/ListItem";

const SupplierFeatures = () => {
  return <ListItem items={supplierFeatureMenu} />;
};

export default SupplierFeatures;
